export const SET_WHATSAPP_TEMPLATE_LIST = "@PLATFORM/SET_WHATSAPP_TEMPLATE_LIST";
export const SET_WHATSAPP_TEMPLATE = "@PLATFORM/SET_WHATSAPP_TEMPLATE";
